module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/30d93aa5f2b8455444e72d40206571bf.gif";